import { render, staticRenderFns } from "./TheTransactionsHistoryTableHeader.vue?vue&type=template&id=3bb92ef7&scoped=true"
import script from "./TheTransactionsHistoryTableHeader.vue?vue&type=script&lang=js"
export * from "./TheTransactionsHistoryTableHeader.vue?vue&type=script&lang=js"
import style0 from "./TheTransactionsHistoryTableHeader.vue?vue&type=style&index=0&id=3bb92ef7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb92ef7",
  null
  
)

export default component.exports